import { useRouter } from '@ui/lib/i18n';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import { getPosthog } from './common';

type PostHogCustomizedProviderProps = {
  children: React.ReactNode;
};
const LazyProvider = dynamic(
  () => import('posthog-js/react').then((v) => v.PostHogProvider),
  { ssr: true },
);

export const PostHogCustomizedProvider: React.FC<
  PostHogCustomizedProviderProps
> = ({ children }) => {
  const router = useRouter();
  const posthog = usePosthogClient();
  useEffect(() => {
    // Track page views
    const handleRouteChange = () =>
      getPosthog().then((p) => p?.capture('$pageview'));
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return <LazyProvider client={posthog}>{children}</LazyProvider>;
};

const usePosthogClient = () => {
  const [posthog, setPosthog] =
    useState<Awaited<ReturnType<typeof getPosthog>>>();
  useEffect(() => {
    getPosthog().then((p) => {
      setPosthog(p);
    });
  }, []);

  return posthog;
};
